import PropTypes from 'prop-types';
import { useEffect, Fragment, memo } from 'react';
import { useDispatch } from 'react-redux';
import { itinerarySuccess } from '../../../../store/slices/cruise';
import CruiseInformationWithDetails from '../../CruiseInformationWithDetails';

const CruiseItinerary = ({
  itinerary, cruiseBookingResponse, className, doShowPrice, tripId, tripRoomSearchInput,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (itinerary) {
      dispatch(itinerarySuccess(itinerary.itineraryDetail));
    }
  }, [dispatch, itinerary]);
  return (
    <div className={className}>
      <CruiseInformationWithDetails
        tripId={tripId}
        itinerary={itinerary}
        selectedItineraryRow={itinerary.itineraryDetail}
        doShowPrice={doShowPrice}
        tripRoomSearchInput={tripRoomSearchInput}
      />
      {cruiseBookingResponse
        && (
          <>
            <div className="mx-5 mb-5">
              {(cruiseBookingResponse
                .cruiseLineAdvisories || []).length > 0
                && (
                  <>
                    <div><b>Cruise Advisories:</b></div>
                    {cruiseBookingResponse.cruiseLineAdvisories
                      .map((adv) => (
                        <div key={adv.advisoryDescription}>{adv.advisoryDescription}</div>
                      ))}
                  </>
                )}
            </div>
            <div className="mx-5 mb-5">
              {Object.entries(cruiseBookingResponse.cruisePolicies || {})
                .map(([key, value]) => (
                  <Fragment key={key}>
                    <b className="capitalize">{key.toLowerCase()}</b>
                    <div>{value}</div>
                  </Fragment>
                ))}
            </div>
          </>
        )}
    </div>
  );
};

CruiseItinerary.propTypes = {
  itinerary: PropTypes.objectOf(PropTypes.objectOf).isRequired,
  cruiseBookingResponse: PropTypes.objectOf(PropTypes.objectOf),
  className: PropTypes.string,
  doShowPrice: PropTypes.bool,
  tripId: PropTypes.string,
  tripRoomSearchInput: PropTypes.arrayOf(PropTypes.shape()),
};

CruiseItinerary.defaultProps = {
  cruiseBookingResponse: null,
  className: 'border-2 my-3 rounded-lg',
  doShowPrice: true,
  tripId: '',
  tripRoomSearchInput: undefined,
};

export default memo(CruiseItinerary);
